import { Injectable } from "@angular/core";
import { DefaultService } from "../../../core/services/default.service";
import {
  IOwnerShipType,
  IOwnerShipTypeData,
  IOwnerShipTypeInsert,
  IOwnerShipTypeUpdate,
} from "../models/owner-ship-types.interface";
import { ColDef } from "ag-grid-community";
import { ResidentActionsComponent } from "../../../shared/datatable/actions/resident-actions.component";
import { EditOwnerShipTypesFormComponent } from "../pages/status-types/pages/owner-ship-types/edit-owner-ship-types-form/edit-owner-ship-types-form.component";
import { E_ACTIONS, E_SUBJECT } from "../../../core/enums/Permission.enum";

@Injectable({
  providedIn: "root",
})
export class OwnerShipTypesService extends DefaultService<
  IOwnerShipTypeData,
  IOwnerShipTypeInsert,
  IOwnerShipTypeUpdate
> {
  getServiceKey(): string {
    return "OwnerShipTypesService";
  }

  columnDefs: ColDef[] = [
    {
      headerName: "SPRAVOCHNIK.STATUS_TYPES.OWNER_SHIP_TYPES.TABLE_HEADERS.ID",
      field: "id",
      maxWidth: 150,
    },
    {
      headerName:
        "SPRAVOCHNIK.STATUS_TYPES.OWNER_SHIP_TYPES.TABLE_HEADERS.NAME",
      field: "name",
    },
    {
      headerName:
        "SPRAVOCHNIK.STATUS_TYPES.OWNER_SHIP_TYPES.TABLE_HEADERS.SHORT_NAME",
      field: "shortName",
    },
    {
      field: "actions",
      headerName: "TOOLS.RESIDENTS.TABLE_HEADERS.ACTION",
      cellRenderer: ResidentActionsComponent<IOwnerShipType>,
      maxWidth: 100,
      cellRendererParams: {
        handleDelete: this._ability.can(
          E_ACTIONS.DELETE,
          E_SUBJECT.OWNERSHIP_TYPES
        )
          ? this.onDelete.bind(this)
          : null,
        handleEdit: this._ability.can(
          E_ACTIONS.UPDATE,
          E_SUBJECT.OWNERSHIP_TYPES
        )
          ? this.onEdit.bind(this)
          : null,
      },
      suppressNavigable: true,
      cellClass: "no-border",
      pinned: "right",
    },
  ];

  constructor() {
    super("user-service/ownership-types");
    this.setDefaultTableParams({});
  }

  onDelete(data: IOwnerShipType) {
    this.selectedRow.set(data);
    this._confirmationDialogService
      .open({
        title: "SPRAVOCHNIK.STATUS_TYPES.OWNER_SHIP_TYPES.MODAL.TITLE_DELETE",
        message:
          "SPRAVOCHNIK.STATUS_TYPES.OWNER_SHIP_TYPES.MODAL.CONFIRMATION_MODAL_TEXT",
      })
      .then((res) => {
        if (res) {
          this.subscriptions = this.delete(data.id).subscribe(() => {
            this._toastService.success("TOAST.TOAST_DELETE");
            this.subscriptions.unsubscribe();
          });
        }
      });
  }

  onEdit(data: IOwnerShipType) {
    this.selectedRow.set(data);
    this._modalService.open({
      component: EditOwnerShipTypesFormComponent,
      title: "SPRAVOCHNIK.STATUS_TYPES.OWNER_SHIP_TYPES.MODAL.TITLE_UPDATE",
    });
  }
}
